import React, { ReactNode } from 'react';
import { useAsyncState } from '@/utils/hooks';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { getProfileDetails } from '@/services/profiles';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { Tabs } from '@ygtechnologies/rubus-ui';
import { BygrProfileDetails } from '@/types';
import ProfileMembers from './ProfileMembers';
import ProfileInvites from './ProfileInvites';
import ProfileDashboard from './ProfileDashboard';
import ProfileProjects from './ProfileProjects';
import ProfileLicenses from './ProfileLicenses';
import { ProfileFeatures } from './ProfileFeatures';
import { ProfileContractorProjects } from './ProfileContractorProjects';
import ProfileHierarchy from './ProfileHierarchy';
// import theme from './ProjectDetails.module.scss';

interface ProfilesDetailsProps {
    // projectId: number;
}

export type ProfileDetailsTab =
    | 'dashboard'
    | 'members'
    | 'invites'
    | 'projects'
    | 'licenses'
    | 'features'
    | 'contractor-projects'
    | 'hierarchy'
    | 'org-view';

interface TabSettings {
    id: ProfileDetailsTab;
    name: string;
    render(opts: { profile: BygrProfileDetails; reloadProfile(): void }): ReactNode;
}

const tabs: TabSettings[] = [
    {
        id: 'dashboard',
        name: 'Dashboard',
        render: (props) => <ProfileDashboard {...props} />,
    },
    {
        id: 'members',
        name: 'Members',
        render: (props) => <ProfileMembers {...props} />,
    },

    {
        id: 'invites',
        name: 'Profile invites',
        render: (props) => <ProfileInvites {...props} />,
    },
    {
        id: 'projects',
        name: 'Projects',
        render: (props) => <ProfileProjects {...props} />,
    },
    {
        id: 'contractor-projects',
        name: 'Contractor projects',
        render: (props) => <ProfileContractorProjects {...props} />,
    },
    {
        id: 'licenses',
        name: 'Licenses',
        render: (props) => <ProfileLicenses {...props} />,
    },
    {
        id: 'features',
        name: 'Features',
        render: (props) => <ProfileFeatures {...props} />,
    },
    {
        id: 'hierarchy',
        name: 'Hierarchy',
        render: (props) => <ProfileHierarchy {...props} />,
    },
];

const ProfileDetails: React.FC<ProfilesDetailsProps> = () => {
    const { profileId, tab } = useParams<{ profileId: string; tab: ProfileDetailsTab }>();
    const [profile, , reloadProfile] = useAsyncState(() => getProfileDetails(+profileId), [profileId], null);

    if (!profile) {
        return <LoadingIndicator />;
    }

    const activeTab = tabs.find((x) => x.id === tab);

    return (
        <>
            {profile.parentProfileId && profile.parentName && (
                <div style={{ marginBottom: 8, fontSize: 14 }}>
                    Parent:{' '}
                    <Link to={`/profiles/${profile.parentProfileId}/dashboard`}>{profile.parentName}</Link>
                </div>
            )}
            <h2>Profile {profile.name}</h2>
            <Tabs.Container activeId={tab} variant="underline">
                {tabs.map((t) => (
                    <Tabs.Tab key={t.id} id={t.id} as={Link} to={`/profiles/${profileId}/${t.id}`} label={t.name} />
                ))}
                <Tabs.Content>
                    <div className="tab-panel">{activeTab?.render({ profile, reloadProfile })}</div>
                </Tabs.Content>
            </Tabs.Container>
        </>
    );
};

export default ProfileDetails;
